import { EnvSettingKey } from '@commonspirit/ngx-environment';

export abstract class SettingKey extends EnvSettingKey {
  public static readonly GoogleMapsKey = 'googlemaps.apiKey';
}
